import { gql } from "@apollo/client";

export default gql`
  mutation updateComplianceProgramParticipantMutation(
    $complianceProgramId: Int!
    $userId: Int!
    $action: ReviewParticipantAction!
    $reason: String
  ) {
    updateComplianceProgramParticipant(
      complianceProgramId: $complianceProgramId
      userId: $userId
      action: $action
      reason: $reason
    ) {
      complianceProgram {
        id
      }
    }
  }
`;
